/*
 * Default Textarea styles
 */
.Textarea {
  display: flex;
  color: var(--brand-control-color-fg-default);
  background-color: var(--brand-color-canvas-default);
  border: none;
  border-radius: var(--brand-borderRadius-medium);
  line-height: var(--brand-text-lineHeight-100);
  transition: var(--brand-control-animation-duration) var(--brand-control-animation-easing);
  transition-property: color, background-color, box-shadow;
}

.Textarea::placeholder {
  color: var(--brand-color-text-muted);
  opacity: 1;
}

.Textarea[disabled] {
  -webkit-text-fill-color: var(--brand-control-color-fg-disabled);
  color: var(--brand-control-color-fg-disabled);
  cursor: not-allowed;
  background-color: var(--brand-control-color-canvas-disabled);
  opacity: 1;
  resize: none;
}

.Textarea:focus {
  outline: none;
}

.Textarea-resize--vertical {
  resize: vertical;
}

.Textarea-resize--horizontal {
  resize: horizontal;
}

.Textarea-resize--none {
  resize: none;
}

.Textarea-resize--both {
  resize: both;
}

/*
 * Sizes
 */
.Textarea--medium {
  font-weight: var(--brand-text-weight-100);
  font-size: var(--brand-text-size-100);
  padding: var(--brand-control-medium-paddingBlock-normal) var(--brand-control-medium-paddingInline-condensed);
}

.Textarea--large {
  font-weight: var(--brand-text-weight-200);
  font-size: var(--brand-text-size-200);
  padding: var(--brand-control-large-paddingBlock-normal) var(--brand-control-large-paddingInline-condensed);
}

/*
 * Visual states
 */
.Textarea--fullWidth {
  width: 100%;
}

/*
 * Textarea wrapper
 */

.Textarea-wrapper--disabled {
  border-color: var(--brand-control-color-border-disabled);
}

.Textarea-wrapper {
  font-family: var(--brand-body-fontFamily);
  display: inline-flex;
  position: relative;
  border: solid var(--brand-borderWidth-thin, 1px) var(--brand-control-color-border-default);
  border-radius: var(--brand-borderRadius-medium);
  transition: var(--brand-control-animation-duration) var(--brand-control-animation-easing);
  transition-property: border;
}

.Textarea-wrapper--invisible {
  border-color: transparent;
}

.Textarea-wrapper--fullWidth {
  display: flex;
}

.Textarea-wrapper:not(.Textarea-wrapper--fullWidth) {
  width: min-content;
}

.Textarea-wrapper--monospace {
  font-family: var(--brand-fontStack-monospace);
}

.Textarea-wrapper:focus-within {
  border-color: var(--brand-control-color-focus);
  box-shadow: 0 0 0 1px var(--brand-control-color-focus);
  outline: none;
}

@media (forced-colors: active) {
  .Textarea-wrapper:focus-within {
    outline: var(--brand-borderWidth-thick) solid Highlight;
    outline-offset: var(--base-size-2);
  }
}

/*
 * Validation
 */

.Textarea-wrapper--success,
.Textarea-wrapper--success.Textarea-wrapper--disabled {
  border-color: var(--brand-color-success-fg);
}

.Textarea-wrapper--error,
.Textarea-wrapper--error.Textarea-wrapper--disabled {
  border-color: var(--brand-color-danger-fg);
}

/* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
@media (prefers-reduced-motion: reduce) {
  .Textarea,
  .Textarea::before,
  .Textarea::after,
  .Textarea * {
    animation: none !important;
    transition: none !important;
    scroll-behavior: auto !important;
  }
}
